<template>
  <div class="main-container">
    <div class="container-wrap">
      <header>
        <div class="header-area">
          <img src="@/assets/pc/logo_dark_BDO.png" />
          <button
            v-if="$root.wallytMode"
            style="margin: 0 0 0 20px"
            @click="setLanguage('zh_CN')"
          >
            Filipino
          </button>
          <button
            v-if="$root.wallytMode"
            style="margin: 0 0 0 20px"
            @click="setLanguage('en')"
          >
            English
          </button>
          <span>Merchant Application</span>
        </div>
      </header>
      <div class="content">
        <router-view></router-view>
      </div>
      <div class="push"></div>
    </div>
    <footer>
      <div class="footer-area">
        <div class="left-area">
          <p>
            BDO Unibank is regulated by the Bangko Sentral ng Pilipinas with
            contact number (+632) 8708-7087 and with email address
            <var>consumeraffairs@bsp.gov.ph</var>, and webchat at
            <var>www.bsp.gov.ph</var>. Deposits are insured by PDIC up to
            P500,000 per depositor. The BDO, BDO Unibank and other BDO-related
            trademarks are owned by BDO Unibank, Inc. BDO Unibank, Inc. © 2012.
            All Rights Reserved
          </p>
        </div>
        <div class="right-area">
          <div class="link-group one">
            <div class="link-item">
              <a
                href="https://www.bdo.com.ph/about-bdo/business-operations"
                target="_blank"
                rel="noopener"
                >About BDO</a
              >
            </div>
            <div class="link-item">
              <a href="https://www.bdo.com.ph/news-and-articles" target="_blank" rel="noopener"
                >Company News</a
              >
            </div>
          </div>
          <div class="link-group two">
            <div class="link-item">
              <a href="https://www.bdo.com.ph/careers" target="_blank" rel="noopener"
                >Careers</a
              >
            </div>
            <div class="link-item">
              <a href="https://www.bdo.com.ph/contact-us" target="_blank" rel="noopener"
                >Contact Us</a
              >
            </div>
          </div>
          <div class="link-group three">
            <div class="link-item">
              <a href="https://www.bdo.com.ph/site-map" target="_blank" rel="noopener"
                >Site Map</a
              >
            </div>
            <div class="link-item">
              <a
                href="https://www.bdo.com.ph/company-disclosures"
                target="_blank"
                rel="noopener"
                >Company Disclosure</a
              >
            </div>
          </div>
          <div class="link-group four">
            <div class="link-item">
              <a
                href="https://www.bdo.com.ph/corporate-governance"
                target="_blank"
                rel="noopener"
                >Corporate Governance</a
              >
            </div>
            <div class="link-item">
              <a
                href="https://www.bdo.com.ph/investor-relations/investment-credit-ratings-information"
                target="_blank"
                rel="noopener"
                >Investor Relations</a
              >
            </div>
          </div>
          <div class="link-group five">
            <div class="link-item">
              <a href="https://www.bdo.com.ph/privacy-statement" target="_blank" rel="noopener"
                >Privacy Statement</a
              >
            </div>
            <div class="link-item">
              <a
                href="https://www.bdo.com.ph/terms-and-conditions"
                target="_blank"
                rel="noopener"
                >Terms And Conditions</a
              >
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Layout",
  methods: {
    setLanguage(value) {
      window.loadI18NData(value, () => {
        console.log(this.$root.i18n);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  height: 100%;
  width: 100%;
  margin: 0 auto;
  min-width: 1366px;

  .container-wrap {
    min-height: 100%;
    margin-bottom: -128px;
    background: #f6f6f6;
    text-align: left;
    header {
      width: 100%;
      min-width: 1116px;
      background: #004EA8;

      .header-area {
        display: flex;
        height: 64px;
        justify-content: space-between;
        align-items: center;
        padding: 0 16px;

        img {
          width: 110px;
          margin-left: -10px;
        }
        span {
          font: normal normal normal 16px/24px Nunito-bold;
          letter-spacing: 0px;
          color: #FFFFFF;
        }
      }
    }
    .content {
      width: 1366px;
      margin: 0 auto;
    }
  }

  footer,
  .push {
    height: 128px;
  }

  footer {
    width: 1366px;
    margin: 0 auto;
    padding: 32px 54px;
    position: relative;
    bottom: 0;

    .footer-area {
      display: flex;

      .left-area {
        width: 578px;
        p {
          text-align: left;
          font: normal normal normal 12px/16px Nunito;
          letter-spacing: 0px;
          color: #656565;

          var {
            font-style: normal;
            text-decoration: underline;
          }
        }
      }

      .right-area {
        width: calc(100% - 578px);
        display: flex;
        font: normal normal normal 12px/16px Nunito-bold;
        letter-spacing: 0px;
        color: #656565;
        opacity: 1;
        flex-wrap: wrap;

        .link-group {
          margin-left: 24px;
          height: 48px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          &.one {
            // width: 95px;
          }

          &.two {
            // width: 66px;
          }

          &.three {
            // width: 124px;
          }

          &.four {
            // width: 137px;
          }

          &.five {
            // width: 134px;
          }
        }

        .link-item {
          cursor: pointer;
          // font-size: 10px;
        }
      }
    }
  }
}
</style>
